import { Component, OnInit } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[gbc-text-button]',
    templateUrl: './text-button.component.html',
    styleUrls: ['./text-button.component.scss'],
    standalone: true
})
export class TextButtonComponent {
}
